// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"251a81a1","488":"2063daa0"}[chunkId] + ".chunk.js";
};